import { compose, withPropsOnChange } from 'recompose';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getEntities, getQueries } from 'dash-front/selectors';
import { selectCurrentPage, selectIds } from 'dash-front/selectors/pagination';

const withCampaigns = compose(
    connect(state => ({
        campaignsById: getEntities(state).campaigns,
        campaignsPending: _.get(getQueries(state), ['GET:campaigns', 'isPending']),
        campaignsStatus: _.get(getQueries(state), ['GET:campaigns', 'status']),
        campaignIds: selectIds(state.pagination, 'campaigns', selectCurrentPage(state.pagination, 'campaigns'))
    })),
    withPropsOnChange(
        (cur, next) =>
            next.campaignsById &&
            Array.isArray(next.campaignIds) &&
            (cur.campaignsById !== next.campaignsById || cur.campaignIds !== next.campaignIds),
        ({ campaignsById, campaignIds }) => ({
            campaigns:
                Array.isArray(campaignIds) && campaignsById
                    ? campaignIds.reduce((acc, id) => {
                          const cur = campaignsById[id];
                          if (cur) {
                              acc.push(cur);
                          }
                          return acc;
                      }, [])
                    : undefined
        })
    )
);

export default withCampaigns;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/enhancers/withCampaigns.js
 **/